import { Component, OnInit, Injector, Input, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { UserblockService } from '../sidebar/userblock/userblock.service';
import { SettingsService } from '../../core/settings/settings.service';
import { MenuService } from '../../core/menu/menu.service';
import { TranslatorService } from '../../core/translator/translator.service';
import { UtilsService } from '@app/core/services/utils.service';
import { ThemeService } from '@app/core/services/theme.service';

const PRATICKO_FALLBACK = 'assets/img/logo_praticko_shuttle.png';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit, OnDestroy {

    @Input() showLogo = true;
    @Input() forcePratickoLogo = false;

    logoUrl: string = PRATICKO_FALLBACK;

    navCollapsed = true;
    menuItems = [];
    router: Router;
    selectedLanguage = '';

    isNavSearchVisible: boolean;

    private logoSub: Subscription;

    constructor(public menu: MenuService, public userblockService: UserblockService, public settings: SettingsService, public injector: Injector, public translator: TranslatorService, private utilsService: UtilsService, public themeService: ThemeService) {
        this.menuItems = menu.getMenu().slice(0, 4);
        this.selectedLanguage = this.translator.getLanguageInUse();
    }

    ngOnInit() {
        this.isNavSearchVisible = false;
        this.router = this.injector.get(Router);

        this.router.events.subscribe(() => {
            window.scrollTo(0, 0);
            this.navCollapsed = true;
        });

        this.logoSub = this.utilsService.companyLogoPath.subscribe((url: string) => {
            this.logoUrl = this.forcePratickoLogo ? PRATICKO_FALLBACK : (url || PRATICKO_FALLBACK);
        });
    }

    ngOnDestroy() {
        this.logoSub?.unsubscribe();
    }

    toggleUserBlock(event) {
        event.preventDefault();
        this.userblockService.toggleVisibility();
    }

    openNavSearch(event) {
        event.preventDefault();
        event.stopPropagation();
        this.setNavSearchVisible(true);
    }

    setNavSearchVisible(stat: boolean) {
        // //console.log(stat);
        this.isNavSearchVisible = stat;
    }

    getNavSearchVisible() {
        return this.isNavSearchVisible;
    }

    toggleOffsidebar() {
        this.settings.toggleLayoutSetting('offsidebarOpen');
    }

    toggleCollapsedSideabar() {
        this.settings.toggleLayoutSetting('isCollapsed');
    }

    isCollapsedText() {
        return this.settings.getLayoutSetting('isCollapsedText');
    }

    // Language
    getLangs() {
        return this.translator.getAvailableLanguages();
    }

    setLang(value) {
        this.translator.useLanguage(value);
        this.selectedLanguage = value;
    }

    // Logout
    logout() {
        //console.log("LOGOUT")
        this.settings.sessionExpired();
        this.router.navigate(["/login/0"]);
    }
}
